import React, {useContext} from 'react';
import {ArticleOverviewGridTeaser} from '../../../../../../../teaser/src/main/resources/scripts/components/article-overview-teaser-content/ArticleOverviewGridTeaser.jsx';
import {articleOverviewStaticContext, ArticleOverviewStaticProvider} from '../ArticleOverviewStatic.jsx';

export default function Teaser({teaserModel, pageModel, clazzes}) {
    return (
        <div className={clazzes}>
            <ArticleOverviewGridTeaser teaserModel={teaserModel} pageModel={pageModel} />
        </div>
    );
}
